import React, { useEffect } from 'react'
import Script from 'next/script'
import Head from 'next/head'
import { Footer, Header } from 'js/components'
import { OrganizationSchema, WebPageSchema, BreadcrumbListSchema } from 'js/schemas'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks
import { FeedbackTop } from '.'

export async function getStaticProps({ locale, locales }) {
  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'homepage.json')

    // Read the file
    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  return {
    props: { content, locale, locales },
  }
}

export default function Feedback({ content, locale, locales }) {
  useEffect(() => {
    ;(function (w, d, i, s) {
      function l() {
        if (!d.getElementById(i)) {
          var f = d.getElementsByTagName(s)[0],
            e = d.createElement(s)
          ;(e.type = 'text/javascript'),
            (e.async = !0),
            (e.src = 'https://canny.io/sdk.js'),
            f.parentNode.insertBefore(e, f)
        }
      }
      if ('function' != typeof w.Canny) {
        var c = function () {
          c.q.push(arguments)
        }
        ;(c.q = []),
          (w.Canny = c),
          'complete' === d.readyState
            ? l()
            : w.attachEvent
              ? w.attachEvent('onload', l)
              : w.addEventListener('load', l, !1)
      }
    })(window, document, 'canny-jssdk', 'script')
    const BOARD_FEATURES_REQUESTS_TOKEN = 'e03c9237-43e0-5271-65bd-470e50205f81'
    Canny('render', {
      boardToken: BOARD_FEATURES_REQUESTS_TOKEN,
      ssoToken: null, // See step 3,
      theme: 'light', // options: light [default], dark, auto
    })
  }, [])

  return (
    <div className="feedback">
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                  gtag('config', 'UA-166939348-2');
              `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
                  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                  })(window,document,'script','dataLayer','GTM-NRW96HD');
              `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
                  (function(h,o,t,j,a,r){
                      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                      h._hjSettings={hjid:2080824,hjsv:6};
                      a=o.getElementsByTagName('head')[0];
                      r=o.createElement('script');r.async=1;
                      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                      a.appendChild(r);
                  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
              `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema
        name={content.feedback.title}
        description={content.feedback.description}
      />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com${locale !== 'en' ? `/${locale}` : ''}`,
          },
          {
            name: 'Feedback',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}feedback`,
          },
          {
            name: 'Feature Rrequests - Feedback',
            url: `https://edworking.com/${
              locale !== 'en' ? `${locale}/` : ''
            }feedback/feature-requests`,
          },
        ]}
      />
      <Head>
        <title>{content.feedback.title}</title>
        <meta itemProp="name" content={content.feedback.title} />
        <meta itemProp="image" content={'/images/EdworkingPreview.png'} />
        <meta itemProp="description" content={content.feedback.description} />
        <meta name="description" content={content.feedback.description} />
        <meta property="og:title" content={content.feedback.title} />
        <meta property="og:description" content={content.feedback.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        <meta itemProp="image" content={'/images/EdworkingPreview.png'} />
        <meta property="og:image" content={'/images/EdworkingPreview.png'} />
        <meta property="og:image" content={'/images/EdworkingPreview.png'} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image" content={'/images/EdworkingPreview.png'} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="150" />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${
              locale1 !== 'en' ? `/${locale1}` : ''
            }/feedback/feature-requests/`}
          />
        ))}
        <link
          rel="alternate"
          href={`https://edworking.com/feedback/feature-requests/`}
          hrefLang="x-default"
        />
        <link
          rel="canonical"
          href={`https://edworking.com/${
            locale !== 'en' ? `${locale}/` : ''
          }feedback/feature-requests`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <Header clean content={content.header} />
      <FeedbackTop />
      <div
        data-canny
        style={{ maxWidth: 1250, margin: 'auto', minHeight: 'calc(100vh - 365px)' }}
      />
      <Footer content={content.footer} />
    </div>
  )
}
